import axios from 'axios';
import {envF} from '../../../env';
import { IKizBatchTrustedRequest } from '../../coreapi-dto/dirs/kiz';

export const actDisagregationKizBatchTrusted = async (
    allIds: string[],
    isTrusted: boolean,
    isBox: boolean,
    batchSize: number = 100
): Promise<void> => {
    const jwtToken = localStorage.getItem('TokenData') as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token,
        },
    };

    const generateUrl = () => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/${isBox ? "KizBox" : "Kiz"}/BatchTrusted`;
      };

    const batches: string[][] = [];

    // Разбиение на пакеты
    for (let i = 0; i < allIds.length; i += batchSize) {
        batches.push(allIds.slice(i, i + batchSize));
    }

    // Последовательная обработка
    for (const batch of batches) {
        try {
            await axios.patch(generateUrl(), {
                ids: batch,
                isTrusted,
            } satisfies IKizBatchTrustedRequest, header);
        } catch (err) {
            console.error(`[ActDisagregationKizBatchTrusted] Ошибка при обработке пакета:`, batch, err);
            throw err;
        }

    }
};